// extracted by mini-css-extract-plugin
export default {"indicatorDots":"_2qbrZ4xV","background":"_2tiSupry","dotWrapper":"_1BS2ZB3J","dot":"_6mQ2PSh1","active":"_2w-gbegQ"};